import React, { useState, useEffect, Fragment } from 'react';
import PropTypes from 'prop-types';
import {
  Row,
  Input,
  Card,
  CardBody,
  CardTitle,
  Button,
  CustomInput,
  Modal,
  ModalHeader,
  ModalBody,
} from 'reactstrap';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import IntlMessages from '../../../../../../helpers/IntlMessages';

import {
  faCommentDots,
  faEdit,
  faTrashAlt,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  AddMessageButton,
  DisabledAddLinkButton,
  DeleteButton,
  DisabledAddImageButton,
} from '../Button/AddButton';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';

import {
  putAPI_Update_Response,
  postAPI_Create_A_Message,
  putAPI_Delete_Response,
} from '../../../../../../constants/APIs';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import { NotificationManager } from '../../../../../../components/common/react-notifications';
import ImageGallery from '../../gallery/index';
import Validation from '../../../../../../components/Validation';
function Title({
  reloadBotResponse,
  code,
  type,
  msg,
  messages,
  example,
  isExample,
  index,
  isAdd,
  setIsAddMsgToFalse,
  numberOfMsg,
  /** for message-link type */
  link,
  caption,
  /** for message-image-carousel type */
  urls,
  captions,
  /** Globle property id from redux */
  propertyId,
  Title,
  SubTitle,
  AllButtons,
  SelectedButtons,
  isEditAble,
  imageUrl,
  locale,
  cardlink,
  selectedLang,
  historyUpdator,
  isHistory,
  isButtonShow,
  title,
  serviceProvider,
}) {
  const [isEditing, setIsEditing] = useState(true);
  const [isEdit, setIsEdit] = useState(isEditAble);
  const [messageInput, setMessageInput] = useState(msg);
  const [titleInput, setTitleInput] = useState(Title);
  const [subTitleInput, setSubTitleInput] = useState(SubTitle);
  const [linkUrlInput, setLinkUrlInput] = useState(cardlink);
  const [linkInput, setLinkInput] = useState(imageUrl);
  const [buttonList, setButtonList] = useState([]);
  const [deleteVisible, setDeleteVisible] = useState(false);
  const [galleryVisible, setGalleryVisible] = useState(false);
  const [open, setOpen] = useState(false);
  const [msgs, setMsgs] = useState([]);
  const [postData, setPostData] = useState({
    GroupId: getGroupID(),
    Code: code,
    Language: `${selectedLang === 'en' ? 'en-US' : selectedLang}`,
    Channel: 'WebsiteDirectLine',
    PropertyId: propertyId === '-1' ? null : propertyId,
    Default: null,
    Overrides: {},
    UserName: historyUpdator
  });
  const toggle = () => {
    setDeleteVisible(!deleteVisible);
  };
  const togglegallery = () => {
    setGalleryVisible(!galleryVisible);
  };

  const selectedImage = (link) => {
    setLinkInput(link.src);
  };

  const handleDelete = (code) => {
    let data;
    if (propertyId !== '-1') {
      data = {
        GroupId: getGroupID(),
        PropertyId: propertyId,
        Language: `${selectedLang === 'en' ? 'en-US' : selectedLang}`,
        Channel: 'WebsiteDirectLine',
      };
    } else {
      data = {
        GroupId: getGroupID(),
        Language: `${selectedLang === 'en' ? 'en-US' : selectedLang}`,
        Channel: 'WebsiteDirectLine',
        UserName: historyUpdator
      };
    }
    AxiosAPI({
      method: 'put',
      url: `${putAPI_Delete_Response}/${code}`,
      data: data,
    })
      .then((res) => {
        //console.log(res.data);
        toggle();
      })
      .finally(
        setTimeout(() => {
          reloadBotResponse();
        }, 1000)
      )
      .catch((err) => {
        console.log(err);
      });
  };
  const handleTextChange = (e) => {
    setTitleInput(e.target.value);
  };

  const handleSubTitleChange = (e) => {
    setSubTitleInput(e.target.value);
  };

  const handleUrlChange = (e) => {
    setLinkInput(e.target.value);
  };
  const handleLinkUrlChange = (e) => {
    setLinkUrlInput(e.target.value);
  };
  const ImageGalleryButton = () => {
    return (
      <Row>
        <Colxx xs="12" sm="12" md="12" lg="12" className="mb-4">
          <Row>
            <Colxx xs="12" sm="3" className="mb-1">
              <Modal
                isOpen={galleryVisible}
                toggle={togglegallery}
                style={{ maxWidth: '1000px' }}
              >
                <ModalHeader toggle={togglegallery}>
                  Select Image or Upload New Image
                </ModalHeader>
                <ModalBody>
                  <ImageGallery
                    propertyId={propertyId}
                    selectedImage={selectedImage}
                    togglegallery={togglegallery}
                    hideUserUploads={false}
                    searchText={''}
                  />
                </ModalBody>
              </Modal>
            </Colxx>
          </Row>
        </Colxx>
      </Row>
    );
  };

  const generateButtonGroup = () => {
    return (
      <Row>
        <Colxx xs="12" sm="12" md="12" lg="8" className="mb-4">
          <Row>
            <Colxx xs="12" sm="3" className="mb-1">
              <Modal isOpen={deleteVisible} toggle={toggle}>
                <ModalHeader toggle={toggle}>
                  <span role="img" aria-label="warning">
                    ⚠️
                  </span>
                  This response will be deleted!
                </ModalHeader>
                <ModalBody>
                  <Button
                    color="danger"
                    onClick={() => handleDelete(code)}
                    size="xs"
                  >
                    Delete
                  </Button>
                  <Button
                    className="ml-2"
                    color="dark"
                    outline
                    size="xs"
                    onClick={toggle}
                  >
                    Cancel
                  </Button>
                </ModalBody>
              </Modal>
            </Colxx>
          </Row>
        </Colxx>
      </Row>
    );
  };

  useEffect(() => {
    const appAddonsArr = buttonList
      .filter((elem) => elem.checked === true)
      .map((elem) => ({
        text: elem.text,
        value: elem.value,
      }));

    setPostData({
      ...postData,
      Default: {
        Title: titleInput,
        SubTitle: subTitleInput,
        ImageUrl: linkInput,
        Buttons: appAddonsArr,
        Link: linkUrlInput,
      },
    });
  }, [titleInput, subTitleInput, linkInput, buttonList, linkUrlInput]);

  useEffect(() => {
    if (SelectedButtons !== undefined) {
      setButtonList(
        AllButtons.map((elem) => {
          elem.checked = false;
          SelectedButtons.forEach((r) => {
            if (r.value === elem.value) {
              elem.checked = true;
              elem.text = r.text;
            }
          });
          return elem;
        })
      );
    } else {
      setButtonList(
        AllButtons.map((p) => ({
          value: p.value,
          text: p.text,
          checked: false,
        }))
      );
    }
  }, []);

  const handleSave = async () => {
    try {
      return await AxiosAPI({
        method: 'put',
        url: putAPI_Update_Response,
        data: postData,
      })
        .then((res) => {
          if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
            && res.data.Messages !== null && res.data.Messages.length > 0) {
            setMsgs(res.data.Messages);
            setOpen(true);
          }
          else {
            NotificationManager.success(
              '',
              'Bot Response Updated.',
              3000,
              null,
              null,
              'success'
            );
            setIsEdit(true);
            setTimeout(() => {
              reloadBotResponse();
            }, 1000);
          }
        })
        .finally(

      );
    } catch (error) {
      console.error(error);
    }
  };

  const handleButtonChange = (e) => {
    console.log(e.target);
    const values = buttonList.map((elem) => {
      if (elem.value === e.target.name) {
        elem.text = e.target.value;
      }
      return {
        ...elem,
      };
    });
    setButtonList(values);
  };

  const handleRoleChange = (e) => {
    const values = buttonList.map((elem) => {
      if (elem.value === e.target.value) {
        if (elem.checked) {
          elem.checked = false;
        } else if (!elem.checked) {
          elem.checked = true;
        }
      }
      return {
        ...elem,
      };
    });
    setButtonList(values);
  };
  const allowedAvenButtons = [
    'seerooms',
    'leavedetails',
    'humanchat',
    'real_person',
    'roomdetails',
  ];
  const titlename = (title || '').toLowerCase().trim();

  const filteredButtons =
    titlename === 'hotel' &&
      (serviceProvider === "5" || serviceProvider === "2")
      ? buttonList.filter(btn =>
        allowedAvenButtons.includes(btn.value)
      )
      : buttonList;
  const Editing = () => {
    return (
      <Fragment>
        {/* <pre>{JSON.stringify(postData, null, 2)}</pre> */}
        <CardTitle>
          <Row>
            <Colxx xxs="6">
              <div>
                <FontAwesomeIcon icon={faCommentDots} />
                <span> </span>
                <IntlMessages id="property.Title" />
              </div>
            </Colxx>
          </Row>
        </CardTitle>
        <Row>
          <Colxx xxs="12">
            <Input
              type="textarea"
              defaultValue={isEdit ? Title : `{ This is an example } ${Title}`}
              onChange={handleTextChange}
            />
          </Colxx>
        </Row>
        <CardTitle>
          <Row>
            <Colxx xxs="6">
              <div>
                <FontAwesomeIcon icon={faCommentDots} />
                <span> </span>
                <IntlMessages id="property.SubTitle" />
              </div>
            </Colxx>
          </Row>
        </CardTitle>
        <Row>
          <Colxx xxs="12">
            <Input
              type="textarea"
              defaultValue={
                isEdit ? SubTitle : `{ This is an example } ${SubTitle}`
              }
              onChange={handleSubTitleChange}
            />
          </Colxx>
        </Row>
        <Row className="mt-5">
          <Colxx xxs="2"> <IntlMessages id='dashboards.imagelink' /></Colxx>
          <Colxx xxs="10">
            <Input
              type="text"
              value={linkInput}
              onChange={handleUrlChange}
            ></Input>
          </Colxx>
        </Row>
        <Row>
          <Colxx xxs="2"></Colxx>
          {isButtonShow &&
            <Colxx xxs="10">
              <div
                className="float-left"
                style={{ marginTop: ' 5px', marginBottom: '5px' }}
              >
                <Button
                  color="primary"
                  className="add-button"
                  size="xs"
                  onClick={togglegallery}
                >
                  <IntlMessages id='dashboards.browsegallery' />
                </Button>
              </div>
            </Colxx>
          }

        </Row>
        {(code === 'todays_deal' || code === 'camping_deals') && (
          <Row className="mt-5">
            <Colxx xxs="2">Link to deals page (optional)</Colxx>
            <Colxx xxs="10">
              <Input
                type="text"
                value={linkUrlInput}
                onChange={handleLinkUrlChange}
              ></Input>
            </Colxx>
          </Row>
        )}
        {ImageGalleryButton()}
        {filteredButtons !== undefined && filteredButtons !== null && filteredButtons.length > 0 && (
          <Row className="mt-5">
            <Colxx xxs="2"><IntlMessages id='menu.buttons' /></Colxx>
            <Colxx xxs="10">
              {filteredButtons.map((elem, index) => (
                <Row key={`buttonRow~${index}`}>
                  <Colxx xxs="6" className="mt-1">
                    <CustomInput
                      key={`buttonChk~${index}`}
                      type="checkbox"
                      value={elem.value}
                      id={elem.value}
                      onChange={handleRoleChange}
                      checked={elem.checked}
                    >
                      {elem.text}
                    </CustomInput>
                  </Colxx>
                  <Colxx xxs="6" className="mt-1">
                    {elem.checked ? (
                      <Input
                        key={`buttontText~${index}`}
                        type="text"
                        value={elem.text}
                        name={elem.value}
                        onChange={handleButtonChange}
                      />
                    ) : null}
                  </Colxx>
                </Row>
              ))}
            </Colxx>
          </Row>
        )}

        <Row className="mt-5">
          <Colxx xxs="6"></Colxx>
          {isButtonShow &&
            <Colxx xxs="6">
              <div className="float-right">
                {isEdit ? (
                  <Fragment>
                    <Button
                      color="secondary"
                      className="add-button"
                      size="xs"
                      onClick={handleSave}
                    >
                      <IntlMessages id='dashboards.save' />
                    </Button>
                    <div
                      onClick={toggle}
                      className="ml-1"
                      style={{ display: 'inline-block' }}
                    >
                      <DeleteButton className="add-button" />
                    </div>
                  </Fragment>
                ) : (
                  <Fragment>
                    {' '}
                    <Button
                      color="secondary"
                      className="add-button"
                      size="xs"
                      onClick={handleSave}
                    >
                      <IntlMessages id='dashboards.save' />
                    </Button>
                  </Fragment>
                )}
                <b> </b>
              </div>
            </Colxx>
          }
        </Row>
        {generateButtonGroup()}
      </Fragment>
    );
  };
  const Showing = () => {
    return (
      <Fragment>
        {/* <pre>{JSON.stringify(postData, null, 2)}</pre> */}
        <CardTitle>
          <Row>
            <Colxx xxs="6">
              <div>
                <FontAwesomeIcon icon={faCommentDots} />
                <span> </span>
                <IntlMessages id="property.Title" />
              </div>
            </Colxx>
          </Row>
        </CardTitle>
        <Row>
          <Colxx xxs="12">
            {Title}
          </Colxx>
        </Row>
        <CardTitle>
          <Row>
            <Colxx xxs="6">
              <div>
                <FontAwesomeIcon icon={faCommentDots} />
                <span> </span>
                <IntlMessages id="property.SubTitle" />
              </div>
            </Colxx>
          </Row>
        </CardTitle>
        <Row>
          <Colxx xxs="12">
            {SubTitle}
          </Colxx>
        </Row>
        {linkInput !== "" &&
          <Row className="mt-5">
            <Colxx xxs="2"> <IntlMessages id='dashboards.imagelink' /></Colxx>
            <Colxx xxs="10">
              <img
                style={{
                  width: '100%',
                  height: '100%',
                }}
                alt="room image"
                src={
                  linkInput || 'https://via.placeholder.com/150/'
                }
              />
            </Colxx>
          </Row>
        }
        {(code === 'todays_deal' || code === 'camping_deals') && linkUrlInput !== "" && (
          <Row className="mt-5">
            <Colxx xxs="2">Link to deals page (optional)</Colxx>
            <Colxx xxs="10">
              {linkUrlInput}
            </Colxx>
          </Row>
        )}
        {SelectedButtons !== undefined && SelectedButtons.length > 0 && (
          <Row className="mt-5">
            <Colxx xxs="2"><IntlMessages id='menu.buttons' /></Colxx>
            <Colxx xxs="10">
              <ul>
                {SelectedButtons.map((elem, index) => (
                  <li key={`buttonRow~${index}`}>{elem.text}</li>
                ))}
              </ul>
            </Colxx>
          </Row>
        )}
      </Fragment>
    );
  };
  return (
    <Card>
      <CardBody>{isHistory === true ? Showing() : Editing()}</CardBody>
      <Validation open={open} messages={msgs} toggle={() => { setOpen(!open) }}></Validation>
    </Card>
  );
}

// Message.propTypes = {
//   code: PropTypes.string.isRequired,
//   type: PropTypes.string.isRequired,
//   msg: PropTypes.string,
//   messages: PropTypes.array,
//   example: PropTypes.string,
//   index: PropTypes.number,
//   isAdd: PropTypes.bool,
//   setIsAddMsgToFalse: PropTypes.func,
//   link: PropTypes.string,
//   caption: PropTypes.string,
// };

const mapStateToProps = ({ settings }) => {
  const { propertyId, locale, serviceProvider } = settings;
  return {
    propertyId,
    locale,
    serviceProvider,
  };
};

export default injectIntl(connect(mapStateToProps)(Title));
